<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">MI</h1>
      </template>
      <template #actions>
        <div class="btn-group btn-group-sm">
          <button
            type="button"
            id="download-report"
            class="btn btn-primary dropdown-toggle"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            Download Report
          </button>
          <div class="dropdown-menu">
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="downloadCsv"
              v-if="hasPermission('mi.full')"
              >MI Export</a
            >
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="downloadActiveDiariesExport"
              v-if="hasPermission('mi.activeDiaries')"
              >Active Diaries Export</a
            >
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="downloadCompletedPdiReport"
              v-if="hasPermission('mi.completedPdi')"
              >Completed PDIs Report</a
            >
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="downloadCustomerReviewReport"
              v-if="hasPermission('mi.customerReview')"
              >Customer Review Report</a
            >
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="downloadHeadsOfClaimReport"
              v-if="hasPermission('mi.headsOfClaim')"
              >Heads Of Claim Report</a
            >
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="downloadHireDeployedExport"
              v-if="hasPermission('mi.hireDeployed')"
              >Hires Depoloyed Export</a
            >
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="downloadNCAReport"
              v-if="hasPermission('mi.nca')"
              >NCA Report</a
            >
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="downloadPenaltiesReport"
              v-if="hasPermission('mi.penalties')"
              >Penalties Report</a
            >
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="downloadTheftReport"
              v-if="hasPermission('mi.theft')"
              >Theft Report</a
            >
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="downloadTotalLossReport"
              v-if="hasPermission('mi.totalLoss')"
              >Total Loss Report</a
            >
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="downloadUtilisationReport"
              v-if="hasPermission('mi.utilisation')"
              >Utilisation Report</a
            >
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="downloadVulnerabilityReport"
              v-if="hasPermission('mi.vulnerability')"
              >Vulnerability Report</a
            >
          </div>
        </div>
      </template>
    </page-header>

    <fieldset>
      <legend>Daily Stats</legend>
      <div class="row half-gutter-bottom">
        <div class="col-lg-6">
          <datepicker
            id="date"
            :value="dailyFilters.date"
            format="dd/MM/yyyy"
            placeholder="dd/mm/yyyy"
            input-class="form-control"
            :disabled="dateRange"
            @selected="setDailyDate"
          ></datepicker>
        </div>

        <div class="col-lg-6">
          <select
            name="referrer_id"
            class="form-control"
            :value="dailyFilters.referrer_id"
            @input="setDailyReferrer"
          >
            <option value="">All Sources</option>
            <option
              :key="index"
              :value="referrer.id"
              v-for="(referrer, index) in referrers"
            >
              {{ referrer.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">Total Claims Created</div>
            <div class="widget-value" v-text="daily.claims"></div>
          </div>
        </div>

        <!--        <div class="col-lg-4">-->
        <!--          <div class="widget widget-primary">-->
        <!--            <div class="widget-label">-->
        <!--              Total Claims Pending Liability Decision-->
        <!--            </div>-->
        <!--            <div class="widget-value" v-text="daily.pending"></div>-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">Total Non-Fault Claims</div>
            <div class="widget-value" v-text="daily.non_fault"></div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">Total Cross Hire Claims</div>
            <div class="widget-value" v-text="daily.cross_hire_claims"></div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">Total Credit Hires Deployed</div>
            <div
              class="widget-value"
              v-text="daily.credit_hires_deployed"
            ></div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">Total Cross Hires Deployed</div>
            <div class="widget-value" v-text="daily.cross_hires_deployed"></div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">Repairs Deployed</div>
            <div class="widget-value" v-text="daily.repairs_deployed"></div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">Salvage Deployed</div>
            <div class="widget-value" v-text="daily.salvage_deployed"></div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">PI Deployed</div>
            <div
              class="widget-value"
              v-text="daily.personal_injuries_deployed"
            ></div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">Fleet Utilisation</div>
            <div
              class="widget-value"
              v-text="daily.fleet_utilisation + '%'"
            ></div>
          </div>
        </div>
      </div>
    </fieldset>

    <fieldset>
      <legend>Monthly Stats</legend>
      <div class="row half-gutter-bottom">
        <div class="col-lg-6">
          <month-picker
            input-class="form-control"
            placeholder="Select Month"
            :disabled="dateRange"
            :value="monthlyFilters.date"
            @input="setMonth"
          ></month-picker>
        </div>

        <div class="col-lg-6">
          <select
            name="referrer_id"
            class="form-control"
            :value="monthlyFilters.referrer_id"
            @input="setMonthlyReferrer"
          >
            <option value="">All Sources</option>
            <option
              :key="index"
              :value="referrer.id"
              v-for="(referrer, index) in referrers"
            >
              {{ referrer.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">Total Claims Created</div>
            <div class="widget-value" v-text="monthly.claims"></div>
          </div>
        </div>

        <!--        <div class="col-lg-4">-->
        <!--          <div class="widget widget-primary">-->
        <!--            <div class="widget-label">-->
        <!--              Total Claims Pending Liability Decision-->
        <!--            </div>-->
        <!--            <div class="widget-value" v-text="monthly.pending"></div>-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">Total Non-Fault Claims</div>
            <div class="widget-value" v-text="monthly.non_fault"></div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">Total Cross Hire Claims</div>
            <div class="widget-value" v-text="monthly.cross_hire_claims"></div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">Total Credit Hires Deployed</div>
            <div
              class="widget-value"
              v-text="monthly.credit_hires_deployed"
            ></div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">Total Cross Hires Deployed</div>
            <div
              class="widget-value"
              v-text="monthly.cross_hires_deployed"
            ></div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">Repairs Deployed</div>
            <div class="widget-value" v-text="monthly.repairs_deployed"></div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">Salvage Deployed</div>
            <div class="widget-value" v-text="monthly.salvage_deployed"></div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="widget widget-primary">
            <div class="widget-label">PI Deployed</div>
            <div
              class="widget-value"
              v-text="monthly.personal_injuries_deployed"
            ></div>
          </div>
        </div>
      </div>
    </fieldset>

    <fieldset class="mb-5" v-if="hasPermission('mi.audits')">
      <legend>User Audits</legend>
      <div class="row gutter-bottom">
        <div class="col-lg-3">
          <datepicker
            id="from"
            :value="userAuditFilters.from"
            format="dd/MM/yyyy"
            placeholder="dd/mm/yyyy"
            input-class="form-control"
            :disabled="dateRange"
            @selected="setFromDate"
          ></datepicker>
        </div>
        <div class="col-lg-3">
          <datepicker
            id="to"
            :value="userAuditFilters.to"
            format="dd/MM/yyyy"
            placeholder="dd/mm/yyyy"
            input-class="form-control"
            :disabled="dateRange"
            @selected="setToDate"
          ></datepicker>
        </div>

        <div class="col-lg-3">
          <select
            name="user_id"
            class="form-control"
            :value="userAuditFilters.user_id"
            @input="setUser"
          >
            <option value="">Select User</option>
            <option
              :key="index"
              :value="user.id"
              v-for="(user, index) in users"
            >
              {{ user.full_name }} - Role: {{ getRoleName(user.role) }}
            </option>
          </select>
        </div>

        <div class="col-lg-3">
          <form-button
            :indicator="userAuditDownloading"
            @clicked="downloadUserAudit"
          >
            Download User Audit Export
          </form-button>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
import MonthPicker from '@/components/Modules/MI/Children/MonthPicker';
import PageHeader from './../Shared/PageHeader.vue';

export default {
  components: {
    PageHeader,
    MonthPicker
  },

  data() {
    return {
      downloading: false,
      userAuditDownloading: false,
      utilisationReportDownloading: false,
      vulnerabilityReportDownloading: false,
      referrers: [],
      dailyFilters: {
        date: new Date(),
        referrer_id: ''
      },
      dateRange: {
        from: new Date()
      },
      userAuditFilters: {
        from: new Date(),
        to: new Date(),
        user_id: ''
      },
      daily: {
        claims: 0,
        non_fault: 0,
        pending: 0,
        cross_hire_claims: 0,
        credit_hires_deployed: 0,
        cross_hires_deployed: 0,
        repairs_deployed: 0,
        salvage_deployed: 0,
        personal_injuries_deployed: 0,
        fleet_utilisation: 0
      },
      monthlyFilters: {
        date: new Date(),
        month: window.DateManager.format(new Date(), 'MM'),
        year: window.DateManager.format(new Date(), 'YYYY'),
        referrer_id: ''
      },
      monthly: {
        claims: 0,
        non_fault: 0,
        pending: 0,
        cross_hire_claims: 0,
        credit_hires_deployed: 0,
        cross_hires_deployed: 0,
        repairs_deployed: 0,
        salvage_deployed: 0,
        personal_injuries_deployed: 0
      }
    };
  },

  computed: {
    users() {
      return this.$store.getters['ClaimHandlers/all'];
    },
    roles() {
      return this.$store.getters['Roles/all'];
    }
  },

  mounted() {
    this.dailyTotals();
    this.monthlyTotals();

    window.Ajax.get('/companies?type=referrer')
      .then(response => {
        this.referrers = response.data.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }

          if (a.name > b.name) {
            return 1;
          }

          return 0;
        });
      })
      .catch(response => {});

    this.$store.commit('ClaimHandlers/retrieve');
    this.$store.commit('Roles/retrieve');
  },

  methods: {
    dailyTotals() {
      const date = window.DateManager.format(
        this.dailyFilters.date,
        'YYYY-MM-DD'
      );

      window.Ajax.get(
        `mi/daily?date=${date}&referrer_id=${this.dailyFilters.referrer_id}`
      )
        .then(response => (this.daily = response.data))
        .catch(error => {
          window.toastify.error(
            'An error occurred while loading the daily stats'
          );
        });
    },

    setDailyDate(date) {
      if (this.dailyFilters.date !== date) {
        this.dailyFilters.date = date;

        this.dailyTotals();
      }
    },

    setFromDate(date) {
      if (this.userAuditFilters.from !== date) {
        this.userAuditFilters.from = date;
      }
    },

    setToDate(date) {
      if (this.userAuditFilters.to !== date) {
        this.userAuditFilters.to = date;
      }
    },

    setDailyReferrer(event) {
      if (this.dailyFilters.referrer_id != event.target.value) {
        this.dailyFilters.referrer_id = event.target.value;

        this.dailyTotals();
      }
    },

    setUser(event) {
      if (this.userAuditFilters.user_id != event.target.value) {
        this.userAuditFilters.user_id = event.target.value;
      }
    },

    monthlyTotals() {
      window.Ajax.get(
        `mi/monthly?month=${this.monthlyFilters.month || ''}&year=${this
          .monthlyFilters.year || ''}&referrer_id=${
          this.monthlyFilters.referrer_id
        }`
      )
        .then(response => (this.monthly = response.data))
        .catch(error => {
          window.toastify.error(
            'An error occurred while loading the monthly stats'
          );
        });
    },

    setMonth(value) {
      this.monthlyFilters.date = value;
      this.monthlyFilters.month = window.DateManager.format(value, 'MM') || '';
      this.monthlyFilters.year = window.DateManager.format(value, 'YYYY') || '';

      this.monthlyTotals();
    },

    setMonthlyReferrer(event) {
      if (this.monthlyFilters.referrer_id != event.target.value) {
        this.monthlyFilters.referrer_id = event.target.value;

        this.monthlyTotals();
      }
    },

    getRoleName(roleName) {
      return this.roles.find(role => role.name === roleName)?.label;
    },

    download() {
      this.downloading = true;

      window.Ajax.download('mi/export')
        .then(() => {
          this.downloading = false;
        })
        .catch(error => {
          this.downloading = false;

          window.toastify.error(
            'Error',
            'There was a problem downloading the export, please try again.'
          );
        });
    },

    downloadCsv() {
      this.downloading = true;

      window.Ajax.download('mi/export?format=csv')
        .then(() => {
          this.downloading = false;
        })
        .catch(error => {
          this.downloading = false;

          window.toastify.error(
            'Error',
            'There was a problem downloading the export, please try again.'
          );
        });
    },

    downloadCompletedPdiReport() {
      this.downloading = true;

      window.Ajax.download('mi/completed-pdi-export')
        .then(() => {
          this.downloading = false;
        })
        .catch(error => {
          this.downloading = false;

          window.toastify.error(
            'Error',
            'There was a problem downloading the export, please try again.'
          );
        });
    },

    downloadActiveDiariesExport() {
      this.downloading = true;

      window.Ajax.download('mi/active-diaries-export')
        .then(() => {
          this.downloading = false;
        })
        .catch(error => {
          this.downloading = false;

          window.toastify.error(
            'Error',
            'There was a problem downloading the export, please try again.'
          );
        });
    },

    downloadCustomerReviewReport() {
      this.downloading = true;

      window.Ajax.download('mi/customer-review-export?format=csv')
        .then(() => {
          this.downloading = false;
        })
        .catch(error => {
          this.downloading = false;

          window.toastify.error(
            'Error',
            'There was a problem downloading the export, please try again.'
          );
        });
    },

    downloadHeadsOfClaimReport() {
      this.downloading = true;

      window.Ajax.download('mi/heads-of-claim-export')
        .then(() => {
          this.downloading = false;
        })
        .catch(error => {
          this.downloading = false;

          window.toastify.error(
            'Error',
            'There was a problem downloading the export, please try again.'
          );
        });
    },

    downloadUserAudit() {
      if (
        this.userAuditFilters.user_id &&
        this.userAuditFilters.to &&
        this.userAuditFilters.from
      ) {
        this.userAuditDownloading = true;

        const from = window.DateManager.format(
          this.userAuditFilters.from,
          'YYYY-MM-DD'
        );
        const to = window.DateManager.format(
          this.userAuditFilters.to,
          'YYYY-MM-DD'
        );

        window.Ajax.download(
          `mi/user-audit-export?from=${from}&to=${to}&user_id=${this.userAuditFilters.user_id}`
        )
          .then(() => {
            this.userAuditDownloading = false;
          })
          .catch(error => {
            this.userAuditDownloading = false;

            window.toastify.error(
              'Error',
              'There was a problem downloading the export, please try again.'
            );
          });
      }
    },

    downloadUtilisationReport() {
      this.downloading = true;

      window.Ajax.download('mi/utilisation-export')
        .then(() => {
          this.downloading = false;
        })
        .catch(error => {
          this.downloading = false;

          window.toastify.error(
            'Error',
            'There was a problem downloading the export, please try again.'
          );
        });
    },

    downloadVulnerabilityReport() {
      this.downloading = true;

      window.Ajax.download('mi/vulnerabilities')
        .then(() => {
          this.downloading = false;
        })
        .catch(error => {
          this.downloading = false;

          window.toastify.error(
            'Error',
            'There was a problem downloading the export, please try again.'
          );
        });
    },

    downloadHireDeployedExport() {
      this.downloading = true;

      window.Ajax.download('mi/hire-deployed-export?format=csv')
        .then(() => {
          this.downloading = false;
        })
        .catch(error => {
          this.downloading = false;

          window.toastify.error(
            'Error',
            'There was a problem downloading the export, please try again.'
          );
        });
    },

    downloadNCAReport() {
      this.downloading = true;

      window.Ajax.download('mi/nca-export')
        .then(() => {
          this.downloading = false;
        })
        .catch(error => {
          this.downloading = false;

          window.toastify.error(
            'Error',
            'There was a problem downloading the export, please try again.'
          );
        });
    },

    downloadPenaltiesReport() {
      this.downloading = true;

      window.Ajax.download('mi/penalties-export')
        .then(() => {
          this.downloading = false;
        })
        .catch(error => {
          this.downloading = false;

          window.toastify.error(
            'Error',
            'There was a problem downloading the export, please try again.'
          );
        });
    },

    downloadTheftReport() {
      this.downloading = true;

      window.Ajax.download('mi/theft-export')
        .then(() => {
          this.downloading = false;
        })
        .catch(error => {
          this.downloading = false;

          window.toastify.error(
            'Error',
            'There was a problem downloading the export, please try again.'
          );
        });
    },

    downloadTotalLossReport() {
      this.downloading = true;

      window.Ajax.download('mi/total-loss-export?format=csv')
        .then(() => {
          this.downloading = false;
        })
        .catch(error => {
          this.downloading = false;

          window.toastify.error(
            'Error',
            'There was a problem downloading the export, please try again.'
          );
        });
    }
  },

  watch: {
    downloading(value) {
      let Button = window.Ladda.create(
        this.$el.querySelector('#download-report')
      );

      if (value) {
        Button.start();
      } else {
        Button.stop();
      }
    }
  }
};
</script>
